import React, { useRef } from "react";

const WebViewforbook = () => {
     const iframeRef = useRef<any>(null);
     React.useEffect(() => {
    const iframeWindow = iframeRef.current.contentWindow;

    iframeWindow.onload = () => {
      iframeWindow.loadparameters(
        "https://apidev.gitaseva.org/v1/api/",
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IjY3ZDAzMTdjOTg0YWZhYjQwMTY4ZThiYyIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL2dpdmVubmFtZSI6IkdpdGFTZXZhIFRlc3RmYmFjY291bnQiLCJzdWIiOiIiLCJqdGkiOiI2NGI2ZjAzZi01MmNmLTQ4NjMtYTI2Zi0wMzc5OGQzMjU2ZWEiLCJsYW5ndWFnZSI6ImhpbmRpIiwidHlwIjoiMSIsInNpZCI6IjAiLCJleHAiOjE3NTkyMjY0NjYsImlzcyI6Imh0dHBzOi8vYXBpZGV2LmdpdGFzZXZhLm9yZzo4MC8iLCJhdWQiOiJodHRwczovL2FwaWRldi5naXRhc2V2YS5vcmc6ODAvIn0.TI_hNepqEy0IUCXB0YoOMUjOD3PFH9NniNJHlDLYlAM",
        "915855ab-7375-4384-b714-142281a2c783",
        "1",
        "5d049f5a61da6d141088d6ed",
        "श्रीमद्भगवद्गीता (मूल)",
        "hindi",
        "false",
        "hindi",
        "1",
        "67d0317c984afab40168e8bc|URL|TIME|iOS",
        "73aa1837-4c24-43af-86a9-f5271484252a",
        "0",
        "",
        "0"
      );
    };
  }, []);
    const params = () => new URLSearchParams(
        // {
        //      "https://apidev.gitaseva.org/v1/api/",
        //      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IjY4Yzk0MGRhZWY1MmFlZjY4ODhjNmZlOSIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL2dpdmVubmFtZSI6IkdpdGEgU2V2YSIsInN1YiI6IiIsImp0aSI6IjZjMjQyOWVjLTRkYTQtNGZhZS1iZWJkLTBhMzUxMmU2NTBkNCIsImxhbmd1YWdlIjoiaGluZGkiLCJ0eXAiOiIyIiwic2lkIjoiMCIsImV4cCI6MTc1OTI5NjU1NywiaXNzIjoiaHR0cHM6Ly9hcGlkZXYuZ2l0YXNldmEub3JnOjgwLyIsImF1ZCI6Imh0dHBzOi8vYXBpZGV2LmdpdGFzZXZhLm9yZzo4MC8ifQ.y2MpjTd8GRtEwrtUWGUj4qXGhHe3AhyUDSCbP_VFiyM",
        //      "d03c41fb-4a2f-444a-a286-2dfc8bf3766e",
        //      "1",
        //     "bookId": "5c3db63989888f24bcc78ddb",
        //     "name": "कल्याणकारी प्रवचन",
        //     "appLanguage": "hindi",
        //     "isTest": "false",
        //     "appLanguageId": "hindi",
        //     "types": "1",
        //     "userId": "68c940daef52aef6888c6fe9|URL|TIME|Android",
        //     "deviceId": "adad5c9e-90f7-4667-9fa9-b22edb6a4ab1",
        //     "someFlag1": "1",
        //     "someOtherField": "",
        //     "someFlag2": "1"
        // }
        
    )
    const fullUrl = `${'https://gitaseva.org/assets/asset_new'}?${params.toString()}`
    return (
        <div className="cursor-pointer">
            <iframe
            ref={iframeRef}
                src={'https://gitaseva.org/assets/asset_new'}
                style={{ width: "100%", height: "600px", border: "none" }}
                allowFullScreen
                title="Book Reader"
                
            />
        </div>

    )
}
export default WebViewforbook;